class ResponseData {
  data
  error
}
export default ResponseData